import ApiService from "../../../common/api.service";

export async function GetPaymentTypes({ commit }) {
  try {
    ApiService.init("heroku");
    commit("PAYMENT_TYPE_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/payment-type/list");
    commit("PAYMENT_TYPE_SUCCESS", _response);
  } catch (error) {
    commit("PAYMENT_TYPE_ERROR", { result: error.message });
  }
}
